<template>
  <div>
    <div v-show="onFavoritesRoute">
      <Grid :providers="providers" :games="games" />
    </div>

    <v-fade-transition :hide-on-leave="true">
      <router-view :providers="providers" :games="games"></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
import Grid from "./components/grid";

export default {
  name: "gamesFavorites",

  props: ["providers", "games"],

  components: { Grid },

  created() {
    this.$nextTick(() => {
      this.$vuetify.goTo(0);
    });
  },

  watch: {
    "$store.state.logged.status"() {
      this.$router.go();
    },
  },

  computed: {
    onFavoritesRoute() {
      return this.$route.name === "casinoFavorites";
    },
  },
};
</script>

<style></style>
